import { DOORSTEP_DELIVERY_SERVICE_TYPE_ID } from '../server/constants.js';
export const getAllSelectedInstallationServices = (form) => {
    const mainServices = form.getAll('mainServices').map(String);
    const subServices = form.getAll('subServices').map(String);
    const individualMainServices = form.getAll('individualMainServices').map(String);
    return [...mainServices, ...subServices, ...individualMainServices];
};
export const getInstallationServiceAccessory = (form) => {
    return form.get('installationServiceAccessory');
};
export const isDoorstepDelivery = (serviceTypeId) => {
    return serviceTypeId === DOORSTEP_DELIVERY_SERVICE_TYPE_ID;
};
//# sourceMappingURL=Helpers.js.map